import type { RegulatorySlice, RegulatoryActions, AppStore } from '@/types/store';
import type { SliceSet, SliceGet } from './types';
import { detectDefaultMode } from '@allergen-lens/shared-logic';

type Slice = RegulatorySlice & RegulatoryActions;

export const createRegulatorySlice = (
  set: SliceSet,
  get: SliceGet
): Slice => ({
  mode: detectDefaultMode(),

  setRegulatoryMode: (mode) => {
    set((state) => {
      const updates: Partial<AppStore> = { mode };
      if (state.activeProfileId) {
        updates.profiles = state.profiles.map((p) =>
          p.id === state.activeProfileId
            ? { ...p, regulatoryMode: mode, updatedAt: new Date().toISOString() }
            : p
        );
      }
      return updates;
    });
    // Trigger re-detection after mode change
    const state = get();
    if (state.tokens.length > 0) {
      setTimeout(() => get().runDetection(), 0);
    }
  },
});
